import {AfterViewInit, ChangeDetectionStrategy, Component, effect, inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '@env/environment';

@Component({
  selector: 'app-trustpilot-carousel-widget',
  templateUrl: './trustpilot-carousel-widget.component.html',
  styleUrls: ['./trustpilot-carousel-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class TrustpilotCarouselWidgetComponent implements AfterViewInit {
  private readonly platformId = inject(PLATFORM_ID);
  
  constructor() {
    // Trigger widget load when component is rendered
    if (isPlatformBrowser(this.platformId) && this.showWidget) {
      effect(() => {
        // Use a small delay to ensure DOM is ready
        setTimeout(() => this.loadTrustpilotWidget(), 200);
      });
    }
  }
  
  /**
   * Show Trustpilot widget based on environment configuration
   */
  readonly showWidget = environment.trustpilot?.enabled ?? false;
  
  /**
   * Widget configuration from environment
   */
  readonly widgetConfig = environment.trustpilot?.widgets.carousel ?? {};
  readonly locale = environment.trustpilot?.locale ?? 'da-DK';
  readonly businessunitId = environment.trustpilot?.businessunitId ?? '';
  readonly reviewPageUrl = environment.trustpilot?.reviewPageUrl ?? '';
  
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.showWidget) {
      this.loadTrustpilotWidget();
    }
  }
  
  private loadTrustpilotWidget(): void {
    // Load Trustpilot script if not already loaded
    if (!document.getElementById('trustpilot-widget-script')) {
      const script = document.createElement('script');
      script.id = 'trustpilot-widget-script';
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      document.head.appendChild(script);
      
      script.onload = () => {
        this.refreshWidget();
      };
    } else {
      // Script already loaded, just refresh the widget
      this.refreshWidget();
    }
  }
  
  private refreshWidget(): void {
    // Give Trustpilot script time to initialize before loading widget
    setTimeout(() => {
      const trustpilot = (window as any).Trustpilot;
      if (trustpilot && trustpilot.loadFromElement) {
        // Find the carousel widget specifically by template ID
        const trustboxElements = document.querySelectorAll('.trustpilot-widget');
        trustboxElements.forEach((element) => {
          const templateId = element.getAttribute('data-template-id');
          // Carousel template ID
          if (templateId === '53aa8912dec7e10d38f59f36') {
            trustpilot.loadFromElement(element, true);
          }
        });
      }
    }, 100);
  }
}
